import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ChatScreen from "./ChatScreen";
import ViewChatHistory from "./ViewChatHistory";
import "./App.css";

function App() {
  return (
    <Router>
      <div
        className="App"
        style={{
          background: "linear-gradient(135deg, #00BF63 0%, #69C8FF 100%)",
        }}
      >
        <Routes>
          <Route path="/" element={<ChatScreen />} />
          <Route
            path="/view-chat-history/:userId"
            element={<ViewChatHistory />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
